module.exports = __webpack_public_path__ + "static/media/hearts.0e36138f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/WallboardShowcase/hearts.svg
// module id = 226
// module chunks = 0